export default "-Grupo Garoce- 0X12\n"